module.exports = __webpack_public_path__ + "static/img/u70061.e51c0f03.png";